import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from "react";
import "keen-slider/keen-slider.min.css";
import styled from "@emotion/styled";
import { SliderCarousel } from "./SliderCarousel";
import { useElementsContext } from "../elementsProvider";
import { CardCarousel } from "./CardCarousel";
import { deletedProduct } from "./deletedProduct";
import { useLingui } from "@lingui/react";
export function RTCProductsCarousel({ colorTexts, subelements, typographyTexts, }) {
    const { isMobile, context } = useElementsContext();
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { i18n } = useLingui();
    const placeholderProducts = useMemo(() => ({
        placeholder_1: {
            identifier: "placeholder_1",
            image: {
                id: 1,
                warhole_id: 1,
                thumbnails: {
                    thumbnail: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-1.jpg",
                    small: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-1.jpg",
                    medium: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-1.jpg",
                    large: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-1.jpg",
                    full: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-1.jpg",
                },
            },
            min_price: 3400,
            max_price: 3400,
            name: i18n._("Cambiá tu equipo con ahora 12"),
            url: "",
            language: i18n.locale,
        },
        placeholder_2: {
            identifier: "placeholder_2",
            image: {
                id: 1,
                warhole_id: 1,
                thumbnails: {
                    thumbnail: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-2.jpg",
                    small: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-2.jpg",
                    medium: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-2.jpg",
                    large: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-2.jpg",
                    full: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-2.jpg",
                },
            },
            min_price: 3400,
            max_price: 3400,
            name: i18n._("Accesorios"),
            url: "",
            language: i18n.locale,
        },
        placeholder_3: {
            identifier: "placeholder_3",
            image: {
                id: 1,
                warhole_id: 1,
                thumbnails: {
                    thumbnail: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-3.jpg",
                    small: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-3.jpg",
                    medium: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-3.jpg",
                    large: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-3.jpg",
                    full: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-3.jpg",
                },
            },
            min_price: 3400,
            max_price: 3400,
            name: i18n._("Cambiá tu equipo"),
            url: "",
            language: i18n.locale,
        },
        placeholder_4: {
            identifier: "placeholder_4",
            image: {
                id: 1,
                warhole_id: 1,
                thumbnails: {
                    thumbnail: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-4.jpg",
                    small: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-4.jpg",
                    medium: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-4.jpg",
                    large: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-4.jpg",
                    full: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-4.jpg",
                },
            },
            min_price: 3400,
            max_price: 3400,
            name: i18n._("Música"),
            url: "",
            language: i18n.locale,
        },
    }), [i18n]);
    const sliderSize = products.length;
    useEffect(() => {
        setIsLoading(true);
        const ids = [];
        const productsIDs = [];
        const placeholderIDs = [];
        subelements.forEach(({ productId }) => {
            if (productId.includes("placeholder")) {
                placeholderIDs.push(productId);
            }
            else {
                productsIDs.push(productId);
            }
            ids.push(productId);
        });
        const apiUrl = context === "ecommerce"
            ? `${process.env.REACT_APP_API}/v1/${window.STORE_ID}/designer/products/?ids=`
            : `${process.env.REACT_APP_SERVER_URL}/api/v4/publications/SP/publications/?ids_eq=`;
        if (productsIDs.length <= 0) {
            const result = [];
            ids.forEach(id => {
                result.push(placeholderProducts[id]);
            });
            setProducts(result);
            setIsLoading(false);
        }
        if (productsIDs.length > 0) {
            fetch(apiUrl + productsIDs.join(","))
                .then(response => response.json())
                .then((response) => {
                const result = [];
                ids.forEach((id, index) => {
                    if (placeholderIDs.includes(id)) {
                        result.push(placeholderProducts[id]);
                    }
                    else {
                        const product = response.objects.find(product => product.identifier === id);
                        if (context === "ecommerce" &&
                            product != null &&
                            product.status !== "PA") {
                            result.push(product);
                        }
                        if (context === "editor") {
                            result.push(product || Object.assign(Object.assign({}, deletedProduct["deleted"]), { identifier: `deleted${index}` }));
                        }
                    }
                });
                setProducts(result);
            })
                .catch(console.error)
                .finally(() => setIsLoading(false));
        }
    }, [context, placeholderProducts, subelements]);
    if (isLoading) {
        //TODO: reemplazar por loading cuando este definido
        return null;
    }
    if (products.length <= 0) {
        return null;
    }
    const cardsPerSlide = isMobile ? 1 : 4;
    const isSliderActive = sliderSize > cardsPerSlide;
    if (!isSliderActive) {
        return (_jsx(CardsContainer, Object.assign({ isDesktop: !isMobile }, { children: products === null || products === void 0 ? void 0 : products.map(subelement => (_jsx(CardCarousel, { subelement: subelement, colorTexts: colorTexts, typographyTexts: typographyTexts, isMobile: isMobile, cardWidth: isMobile ? 268 : 328, isSliderActive: isSliderActive, context: context }, subelement.identifier))) }), void 0));
    }
    return (_jsx(SliderCarousel, { colorTexts: colorTexts, skin: "1", products: products, typographyTexts: typographyTexts, cardsPerSlide: cardsPerSlide, isSliderActive: isSliderActive }, void 0));
}
const CardsContainer = styled.section(({ isDesktop }) => (Object.assign({ display: "grid", alignItems: "center", gridAutoFlow: "column", justifyContent: "center", gridGap: "0.8rem", padding: "0.8rem 0px" }, (isDesktop
    ? {
        gridGap: "1.6rem",
        width: "100%",
        gridAutoColumns: "auto",
    }
    : {}))));
//# sourceMappingURL=RTCProductsCarousel.js.map